<template>
  <!-- total > 10 &&  -->
  <a-pagination
    :current="page"
    :pageSize="size"
    @change="pageChange"
    size="small"
    :show-total="(total, range) => `${range[0]}〜${range[1]}件/${total}件`"
    :total="total"
    :page-size-options="pageSizeOptions"
    show-size-changer
  >
    <template #buildOptionText="props">
      <span v-if="props.value !== '99999'">{{ props.value }} 件 / ページ</span>
      <span v-else>すべて表示</span>
    </template>
  </a-pagination>
</template>
<script>
import { ref } from '@vue/reactivity'
export default {
  props: {
    total: {
      required: true,
    },
    page: {
      required: true,
    },
    size: {
      required: true,
    },
    moreFn: {
      required: true,
    },
  },
  setup(props, { emit }) {
    const pageSizeOptions = ref(['10', '99999'])
    const showAll = () => {
      emit('update:page', 1)
      emit('update:size', 99999)
      props.moreFn()
    }
    const pageChange = (page, pageSize) => {
      emit('update:size', pageSize)
      emit('update:page', page)
      props.moreFn()
    }
    return {
      pageSizeOptions,
      showAll,
      pageChange,
    }
  },
}
</script>
<style></style>
